import React, { Component, Fragment } from 'react'
import {Navbar,Container, Row, Col,Button} from 'react-bootstrap';
import Logo from '../../assets/images/easyshop.png';
import Bars from '../../assets/images/bars.png';
import {Link, Redirect} from "react-router-dom";
import MegaMenuAll from '../home/MegaMenuAll';
import axios from 'axios';
import AppURL from '../../api/AppURL';
 
   
 class NavMenuDesktop extends Component {

     constructor(){
          super();
          this.state={
               SideNavState: "sideNavClose",
               ContentOverState: "ContentOverlayClose",
               Searchkey:"",
               SearchRedirectStauts:false,
               cartCount:0
          }
          this.SearchOnChange = this.SearchOnChange.bind(this);
          this.SeachOnClick = this.SeachOnClick.bind(this);
          this.searchRedirect = this.searchRedirect.bind(this);
          this.handleKeyDown = this.handleKeyDown.bind(this);

     }

     componentDidMount(){
          // let product_code = this.props.product_code;
          let email = localStorage.getItem('email');
          axios.get(AppURL.CartCount(email)).then((response)=>{
               this.setState({cartCount:response.data})

          })
     }



     logout = () => {
          localStorage.clear();

     }

     handleKeyDown(event) {
          if (event.keyCode === 13) {
               this.setState({SearchRedirectStauts:true})
          }
     }

     SearchOnChange(event){
          let Searchkey = event.target.value;
          // alert(Searchkey);
          this.setState({Searchkey:Searchkey});
          if(this.state.Searchkey.length>=4){
                this.setState({SearchRedirectStauts:true})
           }        
     }
//react function enter key press 
     SeachOnClick(){
          if(this.state.Searchkey.length>=2){
               this.setState({SearchRedirectStauts:true})
          }
     }

     searchRedirect(){
          if(this.state.SearchRedirectStauts===true){
               return <Redirect to={"/productbysearch/"+this.state.Searchkey} />
          }
     }



     MenuBarClickHandler=()=>{
          this.SideNavOpenClose();
     }

     ContentOverlayClickHandler=()=>{
          this.SideNavOpenClose();
     }


     SideNavOpenClose=()=>{
          let SideNavState = this.state.SideNavState;
          let ContentOverState = this.state.ContentOverState;
          if(SideNavState==="sideNavOpen"){
               this.setState({SideNavState:"sideNavClose",ContentOverState:"ContentOverlayClose"})

          }
          else{
               this.setState({SideNavState:"sideNavOpen",ContentOverState:"ContentOverlayOpen"})
          }
     }

     // SUN 2022-09-25 08:11:55 CounterRefreshPage for Mobile Device / Use by Home Button 
  // common.css body tag overscroll-behavior-y: contain; 
  
     CounterRefreshPage = () => {          

          let email = localStorage.getItem('email');
          axios.get(AppURL.CartCount(email)).then((response)=>{
               this.setState({cartCount:response.data})

          })
      
          window.location.href="/";
          
     }

     render() {
          let buttons;
          if(localStorage.getItem('token')){
               buttons = (
                    <div>
 {/*
 * Sun 2022-08-07 17:23:47 -- Disabled buttons such as notification and favorites. 
  <Link to="/favourite" className="btn"><i className="fa h4 fa-heart"></i><sup><span className="badge text-white bg-danger">3</span></sup>                  
                   </Link> 

                   <Link to="/notification" className="btn"><i className="fa h4 fa-bell"></i><sup><span className="badge text-white bg-danger">5</span></sup>                  
                   </Link> */}
                   <Link to="/" onClick={this.CounterRefreshPage} className="h4 btn">HOME</Link>
                   <Link to="/profile" className="h4 btn">PROFILE</Link>
                   <Link to="/" onClick={this.logout} className="h4 btn">LOGOUT</Link>
                   
       <Link to="/cart" className="cart-btn"><i className="fa fa-shopping-cart"></i> {this.state.cartCount} Items </Link>
                    </div> 
               )

          }else{
               buttons = (
                    <div>
 {/* <Link to="/favourite" className="btn"><i className="fa h4 fa-heart"></i><sup><span className="badge text-white bg-danger">3</span></sup>                  
                   </Link> 

                   <Link to="/notification" className="btn"><i className="fa h4 fa-bell"></i><sup><span className="badge text-white bg-danger">5</span></sup>                  
                   </Link>
                    */}
                   <Link to="/login" className="h4 btn">LOGIN</Link>
                   <Link to="/register" className="h4 btn">REGISTER</Link>
                   
       <Link to="/cart" className="cart-btn"><i className="fa fa-shopping-cart"></i> 0 Items </Link>
                    </div> 
               )

          }



          return (
               <Fragment>
<div className="TopSectionDown">
<Navbar fixed={"top"} className="navbar" bg="light">

    <Container fluid={"true"} className="fixed-top shadow-sm p-2 mb-0 bg-white">
         <Row>
              <Col lg={4} md={4} sm={12} xs={12}>

              
              <img onClick={this.MenuBarClickHandler} className="bar-img" src={Bars} />

              <Link to="/" onClick={this.CounterRefreshPage}> <img className="nav-logo" src={Logo} /> </Link>
              </Col>


<Col className="p-1 mt-1" lg={4} md={4} sm={12} xs={12}>
     <div className="input-group w-100">
     <input onChange={this.SearchOnChange}  onKeyDown={this.handleKeyDown} type="text" className="form-control" />
     <Button onClick={this.SeachOnClick} type="button" className="btn site-btn"><i className="fa fa-search"> </i> 
     </Button>
     </div>
</Col>

              <Col className="p-1 mt-1" lg={4} md={4} sm={12} xs={12}>
              
             {buttons}

              </Col>

         </Row> 
   {this.searchRedirect()}
    </Container>

  </Navbar>
  </div>

  <div className={this.state.SideNavState}>
                <MegaMenuAll />
          </div>

               <div onClick={this.ContentOverlayClickHandler} className={this.state.ContentOverState}>

               </div>



               </Fragment>
          )
     }
}

export default NavMenuDesktop
